import {Formik} from "formik";
import {useState} from "react";
import FormNhanSu from "./components/FormNhanSu";
import * as Yup from "yup";
import {QuanLyNhanSuProvider} from "../../contexts/quanLyNhanSu";

interface Props {
  warehouseId?: number;
  className?: any;
}

export const QuanLyNhanSu = (props: Props) => {
  const {warehouseId, className} = props;
  const [dsNhanSu, setDsNhanSu] = useState([]);
  const [detailNhanSu, setDetailNhanSu] = useState({});

  let validationSchema = Yup.object({});
  const handleFormSubmit = (values: any) => {
  }

  return (
    <Formik<any>
      initialValues={{}}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
    >
      <QuanLyNhanSuProvider
        value={{
          dsNhanSu: dsNhanSu,
          setDsNhanSu: setDsNhanSu,
          detailNhanSu,
          setDetailNhanSu,
        }}
      >
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1">
              <FormNhanSu
                className={className}
                warehouseId={warehouseId}
              />
            </div>
          </div>
        </div>

      </QuanLyNhanSuProvider>
    </Formik>

  )
}

export default QuanLyNhanSu;
